export default defineNuxtPlugin(() => {
  return {
    provide: {
      addComma: (number: number) => {
        return number ? number.toLocaleString() : '-'
      }
    }
  }
})
